import React from 'react'
import Viewrecord from '../ViewRecordComponent/ViewRecord'
import { Container } from 'reactstrap';
const patientShowInfo = () => {

    // const [buttonState, setButtonState] = useState({
    //     modalIsOpen: false
    // })


    return (
        <Container>
            <Viewrecord />
            <br />
        </Container>
    )

}

export default patientShowInfo;